var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistantIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5203_11408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2602 11.6824L3.0784 17.6939L0.674396 16.3855C0.411855 16.2425 0.400655 15.8697 0.654161 15.7113L9.05435 10.4766L10.2602 11.6824Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5088 14.931L8.26541 23.3225C8.10701 23.576 7.73416 23.5648 7.59125 23.3023L6.28278 20.8983L12.2898 13.8594L13.5982 15.0204",
    fill: "#FD7DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2856 12.7071L5.71614 18.2598C5.61497 18.3609 5.46659 18.3987 5.32937 18.3582L3.07831 17.6932L10.2601 11.6816L11.2856 12.7071Z",
    fill: "#FD7DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2943 13.7156L6.28273 20.8974L5.61775 18.6464C5.57723 18.5092 5.61497 18.3608 5.71615 18.2596L11.2857 12.707L12.2943 13.7156Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1432 1.98828L5.67699 5.17473C5.38918 5.29755 5.39021 5.70593 5.67869 5.82729L9.89577 7.81736L13.1432 1.98828Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0421 10.875L18.853 18.3503C18.7302 18.6381 18.3218 18.6371 18.2005 18.3486L16.0342 13.9519L22.0421 10.875Z",
    fill: "#FDCB50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5163 9.43806C23.5817 9.81082 23.3965 10.1827 23.0597 10.3552L13.8677 15.0629C13.7782 15.1087 13.6693 15.0916 13.5982 15.0205L9.00293 10.4253C8.93183 10.3542 8.9147 10.2453 8.96053 10.1558L13.6683 0.963804C13.8408 0.626957 14.2126 0.441827 14.5854 0.507145L21.5882 1.73416C21.9463 1.79689 22.2266 2.07726 22.2894 2.43529L23.5163 9.43806Z",
    fill: "#6864F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1793 7.77623L17.9379 5.58042C18.246 5.49322 18.5303 5.77759 18.4431 6.08569L16.2473 13.8443L13.8398 15.1932L9.00299 10.4253L10.1793 7.77623Z",
    fill: "#FD7DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2857 12.707L5.7162 18.2596C5.61503 18.3608 5.46665 18.3986 5.32943 18.358L3.07837 17.6931",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2602 11.6824L3.0784 17.6939L0.674396 16.3855C0.411855 16.2425 0.400655 15.8697 0.654161 15.7113L9.05435 10.4766",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71621 18.2608C5.61503 18.362 5.57729 18.5103 5.61781 18.6476L6.28279 20.8986L12.2943 13.7168",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28278 20.899L7.59125 23.303C7.73416 23.5655 8.10701 23.5767 8.26541 23.3232L13.5088 14.9316",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1432 1.98828L5.67699 5.17473C5.38918 5.29755 5.39021 5.70593 5.67869 5.82729L9.89577 7.81736",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0422 10.877L18.8531 18.3522C18.7303 18.6401 18.3219 18.639 18.2006 18.3506L16.0344 13.9538",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5163 9.43806C23.5817 9.81082 23.3965 10.1827 23.0597 10.3552L13.8677 15.0629C13.7782 15.1087 13.6693 15.0916 13.5982 15.0205L9.00293 10.4253C8.93183 10.3542 8.9147 10.2453 8.96053 10.1558L13.6683 0.963804C13.8408 0.626957 14.2126 0.441827 14.5854 0.507145L21.5882 1.73416C21.9463 1.79689 22.2266 2.07726 22.2894 2.43529L23.5163 9.43806Z",
    stroke: "#052A75",
    strokeWidth: 0.941176,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5203_11408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon6);
export default __webpack_public_path__ + "static/media/assistant-icon-6.86c17f4252314e6c0d881db23eb71fca.svg";
export { ForwardRef as ReactComponent };